export const theme = {
  colors: {
    primary: '#0C2340',      // Tmavě modrá
    secondary: '#C8102E',    // Červená
    background: '#1E1E1E',   // Tmavě šedá
    text: '#FFFFFF',         // Bílá
    accent: '#05c6ed',       // Světle modrá
    success: '#28a745',      // Zelená
    warning: '#ffc107',      // Žlutá
    danger: '#dc3545',       // Červená (pro chyby)
    gray: '#6c757d',         // Šedá
    lightGray: '#343a40'     // Světlejší šedá
  },
  fonts: {
    main: "'Roboto', sans-serif",
    heading: "'Roboto Condensed', sans-serif"
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px'
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.2)',
    large: '0 8px 16px rgba(0, 0, 0, 0.3)'
  }
};
